import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { UserPreferences } from '@repo/user-types'

const initialState: GenericOperationState<UserPreferences | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: userPreferencesDataActions, reducer: userPreferencesDataReducer } =
  createOperationSlice<
    UserPreferences | null,
    SliceCaseReducers<GenericOperationState<UserPreferences | null>>,
    void
  >({
    name: '@users/userPreferences',
    initialState,
    reducers: {},
  })

const editInitialState: GenericOperationState<null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: editUserPreferencesActions, reducer: editUserPreferencesReducer } =
  createOperationSlice<null, SliceCaseReducers<GenericOperationState<null>>, UserPreferences>({
    name: '@users/editUserPreferences',
    initialState: editInitialState,
    reducers: {},
  })
